import React, { FC } from "react"

import { Box, Card, Grid, Group, Space, Stack, Text } from "@mantine/core"
import { IconBolt, IconMapPin, IconRouter, IconUser } from "@tabler/icons-react"
import dayjs from "dayjs"

import Page from "../components/layouts/page/Page"
import { useAuth } from "../contexts/authentication-context"
import StatCard from "../features/home/components/stat-card/StatCard"
import { useDevices } from "../contexts/devices-context"
import { useLanguage } from "../contexts/language-context"
import { useStatistics } from "../contexts/statistics-context"
import { useUsers } from "../contexts/users-context"
import { Link, useNavigate } from "react-router-dom"
import DeviceMap from "../features/devices/components/device-details-card/DeviceMap"

const Home: FC = () => {
    const { user } = useAuth()
    const { data: devices, active, loading: devicesLoading } = useDevices()
    const { dataNow, dataPrior, loading: statsLoading } = useStatistics()
    const { data: users, loading: usersLoading } = useUsers()
    const { L } = useLanguage()
    const navigate = useNavigate()
    const greeting =
        dayjs().hour() < 6
            ? L("Good night")
            : dayjs().hour() < 12
            ? L("Good morning")
            : dayjs().hour() < 18
            ? L("Good afternoon")
            : L("Good evening")

    return (
        <Page title={L("Dashboard")} subtitle={`${greeting} ${user?.displayName?.split(" ")[0] ?? ""}`} flipTitles>
            <Grid gutter="xl" columns={30}>
                <Grid.Col span={30} sm={10}>
                    <Link to="/devices" style={{ textDecoration: "none" }}>
                        <StatCard
                            label={L("Active devices")}
                            icon={IconRouter}
                            value={active.length}
                            totalValue={devices.length}
                            loading={devicesLoading}
                        />
                    </Link>
                    <Space h="md" />
                    {/*    Currently no difference between triggers and visits */}
                    {/*    <StatCard*/}
                    {/*        label={L("Visits today")}*/}
                    {/*        icon={IconDoorEnter}*/}
                    {/*        value={dataNow.visits}*/}
                    {/*        prevValue={dataPrior.visits}*/}
                    {/*        loading={statsLoading}*/}
                    {/*    />*/}
                    {/*    Currently not recording feed type */}
                    {/*    <StatCard*/}
                    {/*        label={L("Feed types today")}*/}
                    {/*        icon={IconBug}*/}
                    {/*        value={dataNow.feedTypes}*/}
                    {/*        prevValue={dataPrior.feedTypes}*/}
                    {/*        loading={statsLoading}*/}
                    {/*    />*/}
                    <StatCard
                        label={L("Triggers today")}
                        icon={IconBolt}
                        value={dataNow.triggers}
                        prevValue={dataPrior.triggers}
                        loading={statsLoading}
                    />
                    <Space h="md" />
                    <Link to="/settings" style={{ textDecoration: "none" }}>
                        <StatCard label={L("Users")} icon={IconUser} value={users.length} loading={usersLoading} />
                    </Link>
                </Grid.Col>
                <Grid.Col span={30} sm={20}>
                    <Card withBorder p="0.25rem">
                        <Stack spacing="xs" h={"100%"}>
                            <Box m="0.25rem">
                                <Text m={"0.5rem"} color="dimmed" weight="bold" sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
                                    <Group spacing="xs">
                                        <IconMapPin size={20} />
                                        {L("Location")}
                                    </Group>
                                </Text>
                                <Card shadow="" p={0} h={"60dvh"} mt={"0.25rem"}>
                                    <DeviceMap
                                        markers={
                                            devices.map(device => {
                                                return device.coordinates ? {
                                                    label: device.name,
                                                    latitude: device.coordinates.latitude,
                                                    longitude: device.coordinates.longitude,
                                                    onClick: () => navigate(`devices/${device.id}`),
                                                } : null
                                            }).filter(e => e !== null)
                                        }
                                    />
                                </Card>
                            </Box>
                        </Stack>
                    </Card>
                </Grid.Col>
            </Grid>
        </Page>
    )
}

export default Home
